<template>
  <BaseModal
    :is-editable="false"
    :is-archivable="false"
    :is-visible="isVisible"
    size="xl"
    @hideModal="hideModal()"
  >
    <template #header>
        {{ $t('views.surveys.list.sendSurveyToContractor') }}
    </template>
    <template #body>
      <b-row align-h="around">
        <b-col cols="12">
          <div class="form-group">
            <label class="form-control-label">{{ $t('views.financialreport.list.contractor') }}:</label><br>
            <base-select-input
              v-model="idUserData"
              :search-callback="userDataSearchCallback"
              :display-values="['fullName', 'firmname1']"
              :query-param="'userdata'"
              :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
            ></base-select-input>
          </div>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <label for="custom_email_content">{{ $t('views.appconfiguration.invoiceConfiguration.externalSurveyEmailContent') }}:</label>
            <trumbowyg ref="editor" v-model="preparedEmailContent" :config="trumbowygConfig" class="form-control" name="htmlContent">
            </trumbowyg>
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="documentsToSendFromSurvey.length > 0">
          <h6>{{ $t('views.surveys.list.sendSurveyDocumentsInfo') }}:</h6>
          <table class="table table-hover table-sm table-striped mb-2">
            <tbody>
            <tr v-for="document in documentsToSendFromSurvey"
                :key="document['@id']">
              <td style="word-break: break-all">
                {{ document['title'] }}
              </td>
              <td style="word-break: break-all">
                {{ document['fileName'] }}
              </td>
              <td>
                {{ $moment(document.createdAt).format('YYYY-MM-DD HH:mm') }}
              </td>
              <td>
                <span v-if="document.idDocumentType">{{ document.idDocumentType.title }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </b-col>
        <b-col>
          <button type="button" class="btn btn-danger" @click="hideModal()">{{$t('buttons.cancel')}}</button>
        </b-col>
        <b-col>
          <button type="button" class="btn btn-success float-right" @click="sendSurveyToContractorAction">{{$t('buttons.send')}}</button>
        </b-col>
      </b-row>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'
import ApiService from '@/utils/ApiService'
import Trumbowyg from 'vue-trumbowyg'

export default {
  name: 'SendSurveyToContractorModal',
  components: {
    BaseSelectInput,
    BaseModal,
    Trumbowyg
  },
  computed: {
    ...mapGetters({
      isVisible: 'surveys/list/getIsSendSurveyToContractorModalVisible',
      getSendSurveyToContractorId: 'surveys/list/getSendSurveyToContractorId'
    }),
    documentsToSendFromSurvey () {
      if (this.surveyToSendData && this.surveyToSendData.documentFiles) {
        return this.surveyToSendData.documentFiles.filter(document => document.attachToEmail)
      }
      return []
    }
  },
  data () {
    return {
      idUserData: null,
      preparedEmailContent: '',
      surveyToSendData: null,
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btnsDef: {
          // Create a new dropdown
          image: {
            dropdown: ['insertImage'], /*, 'base64' */
            ico: 'insertImage'
          },
          insertText: {
            fn: () => this.insertText(),
            ico: 'blockquote'
          }
        },
        btns: [
          ['viewHTML'],
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['insertText']
        ],
        lang: this.$i18n.locale
      }
    }
  },
  watch: {
    isVisible (newVal) {
      if (newVal) {
        this.idUserData = null
        this.getPreparedEmailContent()
        this.getSurveyInfo()
      }
    }
  },
  methods: {
    hideModal () {
      this.toggleSendSurveyToContractorModal()
    },
    ...mapMutations({
      toggleSendSurveyToContractorModal: 'surveys/list/toggleSendSurveyToContractorModal'
    }),
    ...mapActions({
      sendSurveyToContractor: 'surveys/list/sendSurveyToContractor'
    }),
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async getPreparedEmailContent () {
      let owner = await new ApiService('owners/1').getResults()
      if (owner.externalSurveyEmailContent) {
        this.preparedEmailContent = owner.externalSurveyEmailContent
      }
    },
    async getSurveyInfo () {
      if (this.getSendSurveyToContractorId) {
        this.surveyToSendData = await new ApiService(this.getSendSurveyToContractorId).getResults()
      }
    },
    sendSurveyToContractorAction () {
      this.sendSurveyToContractor({ idUserData: this.idUserData, preparedEmailContent: this.preparedEmailContent })
    }
  }
}
</script>
